import type { ButtonVariant } from '@packages/ui/primitives';

/** Semantic add-button variants declared in orch.json → DS ButtonVariant. */
const ADD_BUTTON_VARIANT_MAP: Record<string, ButtonVariant> = {
  primary: 'primary',
  'primary-outline': 'primary-outline',
  'primary-dark': 'primary-dark',
  'icon-only': 'primary-icon-button',
  ghost: 'ghost',
  outlined: 'primary-outline',
  secondary: 'secondary',
  'secondary-outline': 'secondary-outline',
};

/** Semantic remove-button variants declared in orch.json → DS ButtonVariant. */
const REMOVE_BUTTON_VARIANT_MAP: Record<string, ButtonVariant> = {
  button: 'secondary-red-outline',
  'secondary-red-outline': 'secondary-red-outline',
  'inline-icon': 'ghost',
  ghost: 'ghost',
  link: 'link',
};

export function resolveAddButtonVariant(variant: string | undefined): ButtonVariant {
  if (variant == null || variant === '') {
    return 'primary-outline';
  }
  return ADD_BUTTON_VARIANT_MAP[variant] ?? 'primary-outline';
}

export function resolveRemoveButtonVariant(variant: string | undefined): ButtonVariant {
  if (variant == null || variant === '') {
    return 'secondary-red-outline';
  }
  return REMOVE_BUTTON_VARIANT_MAP[variant] ?? 'secondary-red-outline';
}
